export const externalPaymentReport = data => {
  if (!data) return data;
  const buyers = (data.buyers || []).filter(buyer => buyer.type !== 'internal_packing');
  return { ...data, buyers, pendingAmount: buyers.reduce((sum, buyer) => sum + Math.round(Number(buyer.pendingAmount || 0) * 100), 0) / 100 };
};
